import React, { useCallback, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux'
import List from 'src/components/grid.component';
import { AuthorizationState, AuthorizationTime, NumberFormatter } from '../service';

const renderNumberColumn = (key) => (cellProps) => {
  const value = cellProps?.dataItem?.[key] || "0";
  return <NumberFormatter value={value} />;
};

const AuthorizationRecordsGrid = (props) => {
  const gridRef = useRef(null);
  const params = useParams();
  const authorizationTime = useCallback((props) => {
    return <AuthorizationTime data={props?.dataItem} />
  }, [])
  const authorizationState = useCallback((props) => {
    return <AuthorizationState data={props?.dataItem} />
  }, [])
  const customcells = {
    "transactionTime": authorizationTime,
    "amount": renderNumberColumn("amount"),
    "beforeAmount": renderNumberColumn("beforeAmount"),
    "afterAmount": renderNumberColumn("afterAmount"),
    "fee": renderNumberColumn("fee"),
    "state": authorizationState
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  return (
    <div className=''>
      <List
        url={process.env.REACT_APP_GRID_API + `api/CardsManageService/AuthorizationRecords/${params?.id}`}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelexport}
        pKey={"AuthorizationRecords"}
        screenName={'Card_ Authorization_Records'}
        renderCustomCell={renderCustomCell}
        showDisplayColumns={false}
      />
    </div>
  )
}
const connectStateToProps = ({ oidc }) => {
  return { userDetails: oidc?.profile.profile }
}
export default connect(connectStateToProps)(AuthorizationRecordsGrid);